module.exports = __webpack_public_path__ + "static/media/cv2.e5311607.png";